import { Redirect, Route, Switch } from 'react-router'
import { dashboardUrl, logoutUrl, opencloudHomeUrl } from 'app/constants'
import store, { type RootState } from 'app/store'
import LogoutPage from 'core/public/LogoutPage'
import { getUserPrefsBucket, preferencesStoreKey } from 'core/session/preferencesReducers'
import { sessionStoreKey } from 'core/session/sessionReducers'
import { isOpenCloud } from 'core/utils/helpers'
import DeveloperToolsEmbed from 'developer/components/DeveloperToolsEmbed'

export const renderPublicPages = () => {
  const state: RootState = store.getState()
  const session = state[sessionStoreKey]
  const { username } = session
  let redirectPath = dashboardUrl

  const userPrefs = getUserPrefsBucket(state?.[preferencesStoreKey], username)
  if (userPrefs) {
    const { lastVisitedPath } = userPrefs?.root || {}
    const defaultUrl = isOpenCloud() ? opencloudHomeUrl : dashboardUrl
    redirectPath = lastVisitedPath ? lastVisitedPath : defaultUrl
  }

  // These must be mutually exclusive: without a Switch, the outer <Switch> in
  // renderMainContent treats this whole block as one path-less (always-matching)
  // child and renders every element inside it at once, so the fallback Redirect
  // fires unconditionally and stomps whichever Route below it should have matched.
  return (
    <Switch>
      <Route path={logoutUrl} component={LogoutPage} />
      <Redirect to={redirectPath} />
    </Switch>
  )
}

export const renderDevTools = () => <DeveloperToolsEmbed />
